<div class="px-px-24 py-px-1" style="background: #F3F8FA;">
  <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; margin-top: 1rem;">
    <h1 style="margin: 0;">Gestion des professionnels de santé</h1>
    <div style="margin-left: auto;">
      <ng-container *appHasPermission="'USER_INVITE'">
        <app-button
          text="Ajouter un professionnel de santé"
          srcIcon="assets/icons/plus.svg"
          (handleClick)="openAddCandidatDialog()"
        ></app-button>
      </ng-container>
    </div>
  </div>

  <div class="inner-add-on left-add-on my-3">
    <input type="search" class="form-control"
           (input)="searchItem($event)"
           placeholder="Rechercher un professionnel de santé" />
    <svg-icon class="inner-icon left" svgClass="placeholder-icon" src="/assets/icons/search-grey.svg"></svg-icon>
  </div>

  <!-- B2 (client clinique — P3) : filtres « Fonction » (secteur) + « Statut » (B1) —
       même rendu que le filtre des sites (carte blanche + chips app-filter-tag). -->
  <div class="quick-filters">
    <div class="card-container p-px-8 quick-filter-group">
      <span class="quick-filter-label">Fonction</span>
      @for (f of fonctionFilters; track f.name) {
        <app-filter-tag [text]="f.name" bgColor="white" color="white"
                        [chipSelected]="f.selected"
                        (handleClick)="toggleFilter(f, $event)"></app-filter-tag>
      }
    </div>
    <div class="card-container p-px-8 quick-filter-group">
      <span class="quick-filter-label">Statut</span>
      @for (s of statutFilters; track s.value) {
        <app-filter-tag [text]="s.name" bgColor="white" color="white"
                        [chipSelected]="s.selected"
                        (handleClick)="toggleFilter(s, $event)"></app-filter-tag>
      }
    </div>
  </div>

  <app-data-table
    [isLoading]="isLoading"
    [dataSource]="candidateListFiltered"
    [columns]="customColumns"
    (onFullRowClick)="handleRowClick($event)"
    [hasRowAction]="true"
    [showSideBar]="true"
    [totalItems]="totalItems"
    (nextPage)="pagination($event)"
    [pageSize]="size"
    [pageIndex]="offset"
  ></app-data-table>
</div>
